(() => {
  const initComparisonReveal = (root = document) => {
    const sections = root.querySelectorAll('.sevenvn-product-comparison:not(.sevenvn-product-comparison--no-reveal)');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach((section) => {
        section.querySelectorAll('[data-comparison-reveal]').forEach((item) => item.classList.add('is-visible'));
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

    sections.forEach((section) => {
      section.querySelectorAll('[data-comparison-reveal]').forEach((item) => observer.observe(item));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initComparisonReveal());
  } else {
    initComparisonReveal();
  }

  document.addEventListener('shopify:section:load', (event) => initComparisonReveal(event.target));
})();
